import React from 'react';
import { useSelector } from 'react-redux';
import TemplateOne from './template1/TemplateOne';

export default function TemplateSelector({ children, ...restProps }) {
  const templateId = useSelector((state) => state.applicationState.templateId);

  return (
    <TemplateOne {...restProps}>{children}</TemplateOne>
  );
}
